var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartpayMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "relayPurple",
    x1: 5,
    y1: 9,
    x2: 54,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A99DF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6753E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "relayTeal",
    x1: 12,
    y1: 31,
    x2: 59,
    y2: 58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BE3D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009A90"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 22 27 7c4-3 8-3 12 0l13 9-10 7-11-7-16 11 7 5-10 7-7-5c-5-3-5-9 0-12Z",
    fill: "url(#relayPurple)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59 43 37 58c-4 3-8 3-12 0l-13-9 10-7 11 7 16-11-7-5 10-7 7 5c5 3 5 9 0 12Z",
    fill: "url(#relayTeal)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartpayMark);
export default __webpack_public_path__ + "static/media/smartpay-mark.bc5e521340e090ceacdc8eb2b036f896.svg";
export { ForwardRef as ReactComponent };